import React from "react";
import { Link } from "gatsby";
import { Div, Image, Text } from "atomize";

import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";

const CtaFooter = ({ content }) => (
  <Div textAlign="center" maxW="45rem" m="5.5rem auto 0" p={{ b: "1rem" }}>
    <ImageLink link="/">
      <Image
        src="/images/trend-logo.svg"
        w="auto"
        h={{ xs: "1rem", sm: "1.25rem" }}
      />
    </ImageLink>
    <Text
      textWeight="700"
      textSize={{ xs: "subheader4", md: "display3" }}
      m={{ t: { xs: "1.25rem", md: "2.25rem" } }}
    >
      {content.ctaTitle}
    </Text>
    <Div d="flex" justify="center" m={{ t: "3rem" }}>
      <AnimateLink to={content.ctaLink}>
        <Div
          className="hero-btn"
          d="flex"
          align="center"
          justify="center"
          textWeight="700"
          bg="primary"
          hoverBg="primary700"
          rounded="circle"
          shadow="primary"
          p="3.5rem 1.5rem 3.4rem"
          w="10.5rem"
          h="10.5rem"
        >
          <Text
            fontFamily="secondary"
            textSize="title"
            textColor="black"
            textAlign="center"
          >
            {content.ctaLabel}
          </Text>
        </Div>
      </AnimateLink>
    </Div>
  </Div>
);

export default CtaFooter;
